import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import LearningStyleBadge from "../../components/LearningStyleBadge";
import CoinBadge from "../../components/CoinBadge";

export default function MiHijo() {
    const { user } = useAuth();
    const [child, setChild] = useState(null);
    const [exams, setExams] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [completedLessons, setCompletedLessons] = useState([]);

    useEffect(() => {
        async function load() {
            if (!user.parent_of) return;
            const childRes = await api.get(`/student-profile/${user.parent_of}`);
            setChild(childRes.data);
            const txRes = await api.get(`/coins/transactions/${user.parent_of}`);
            setTransactions(txRes.data || []);
            // Get exam results
            const ex = await api.get("/exams");
            const results = [];
            for (const e of ex.data || []) {
                try {
                    const r = await api.get(`/exams/${e.id}/results`);
                    results.push(...(r.data || []).filter((x) => x.user_id === user.parent_of));
                } catch (_) {}
            }
            setExams(results);
        }
        load();
    }, [user.parent_of]);

    if (!user.parent_of)
        return <div className="p-6 text-edu-muted">No tienes un hijo/a asociado.</div>;
    if (!child) return <div className="p-6 text-edu-muted">Cargando…</div>;

    return (
        <div className="p-6 md:p-10 fade-in" data-testid="mi-hijo-page">
            <div className="flex items-start justify-between mb-7">
                <div>
                    <h1 className="text-3xl font-semibold">{child.name}</h1>
                    <p className="text-edu-body">{child.grade}</p>
                </div>
                <LearningStyleBadge style={child.learning_style} size="lg" />
            </div>

            <div className="grid md:grid-cols-3 gap-5 mb-7">
                <Card label="Saldo de monedas" value={child.coin_balance} />
                <Card label="Exámenes rendidos" value={exams.length} />
                <Card
                    label="Promedio"
                    value={
                        exams.length
                            ? Math.round(exams.reduce((a, b) => a + b.score_percent, 0) / exams.length) +
                              "%"
                            : "—"
                    }
                />
            </div>

            <div className="grid lg:grid-cols-2 gap-6">
                <div className="edu-card p-6">
                    <h3 className="text-lg font-semibold mb-3">Historial de exámenes</h3>
                    <div className="space-y-2">
                        {exams.length === 0 && <p className="text-sm text-edu-muted">Sin exámenes aún.</p>}
                        {exams.map((e, i) => (
                            <div
                                key={i}
                                className="flex items-center justify-between p-3 bg-[#F8F9FB] rounded-xl"
                            >
                                <div>
                                    <div className="font-medium text-sm">{e.exam_title}</div>
                                    <div className="text-xs text-edu-muted">
                                        {e.subject} · {(e.submitted_at || "").slice(0, 10)}
                                    </div>
                                </div>
                                <div className="text-lg font-semibold">{e.score_percent}%</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="edu-card p-6">
                    <h3 className="text-lg font-semibold mb-3">Movimientos de monedas</h3>
                    <div className="space-y-2 max-h-96 overflow-y-auto edu-scroll">
                        {transactions.length === 0 && <p className="text-sm text-edu-muted">Sin movimientos.</p>}
                        {transactions.map((t, i) => (
                            <div
                                key={i}
                                className="flex items-center justify-between p-3 bg-[#F8F9FB] rounded-xl"
                            >
                                <div>
                                    <div className="text-sm font-medium">{t.concept}</div>
                                    <div className="text-xs text-edu-muted">
                                        {(t.created_at || "").slice(0, 10)}
                                    </div>
                                </div>
                                <CoinBadge amount={t.amount} size="sm" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

function Card({ label, value }) {
    return (
        <div className="edu-card p-5">
            <div className="text-xs uppercase tracking-widest text-edu-muted font-semibold">{label}</div>
            <div className="text-3xl font-bold mt-1">{value}</div>
        </div>
    );
}
